<template>
  <el-dialog :visible="visible" @close="handleCancel" title="结果导出" width="500px">
    <div class="export-result-dialog">
      <div class="dialog-header">
        <h3>结果导出</h3>
        <button class="close-btn" :style="{
          backgroundImage: `url(${require('@imgs/close-card.png')})`,
        }" @click="onCloseClick"></button>
      </div>
      <div class="dialog-body">
        <div class="form-item">
          <span class="required">*</span>
          <span class="label">导出形式：</span>
          <el-radio-group v-model="exportType" class="radio-group">
            <el-radio-button label="0">总分导出</el-radio-button>
            <el-radio-button label="1">单题导出</el-radio-button>
          </el-radio-group>
        </div>
        <div class="form-item" v-if="exportType === '1'">
          <span class="required">*</span>
          <span class="label">选择问卷：</span>
          <el-select v-model="selectedQuestionnaire" placeholder="请选择" @change="handleQuestionnaireChange">
            <el-option v-for="item in this.options" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <div class="dialog-footer">
        <button class="cancel-btn" @click="handleCancel">取消</button>
        <button class="confirm-btn" @click="handleConfirm">确定</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog, RadioButton, RadioGroup, Select, Option, Button } from 'element-ui';
export default {
  name: 'ExportResultDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    accessmentType: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ElDialog: Dialog,
    ElRadioButton: RadioButton,
    ElRadioGroup: RadioGroup,
    ElSelect: Select,
    ElOption: Option,
    ElButton: Button
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.exportType = '';
        this.selectedQuestionnaire = '';
        this.accessmentListRequest()
      }
    }
  },
  computed: {
    hospitalID: function () {
      return this.$store.state.selectedHospital.hospitalid;
    }
  },
  data() {
    return {
      exportType: '',
      selectedQuestionnaire: '',
      options: []
    };
  },
  methods: {
    handleCancel() {
      this.$emit('close', false);
    },
    handleConfirm() {
      if (this.exportType === '') {
        this.$toast.showRed('请选择导出形式');
        return;
      }
      if (this.exportType === '1' && !this.selectedQuestionnaire) {
        this.$toast.showRed('请选择问卷');
        return;
      }
      this.$emit('confirm', {
        exportType: this.exportType,
        questionnaireId: this.selectedQuestionnaire
      });
      this.$emit('close', false);
    },
    handleQuestionnaireChange(value) {
      this.selectedQuestionnaire = value;
    },
    onCloseClick() {
      this.$emit('close', false);
    },
    async accessmentListRequest() {
      const params = {
        "hospitalId": this.hospitalID,
        "type": this.accessmentType
      };
      try {
        const response = await this.$api.assessmentListExport(params);
        this.$set(this, 'options', response.map((accessment) => {
          return {
            title: accessment.title,
            id: accessment.type
          }
        }))

      } catch (error) {
        this.$toast.showRed(error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.export-result-dialog {

  .dialog-header {
    display: flex;
    justify-content: space-between;
    color: #666;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid #e8e8e8;
    padding: 16px 24px;

    .close-btn {
      width: 16px;
      height: 16px;
      background-size: 16px 16px;
      background-repeat: no-repeat;
    }
  }

  .dialog-body {
    padding: 20px;

    .form-item {
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      .required {
        color: #ff4d4f;
        margin-right: 5px;
      }

      .label {
        width: 70px;
        text-align: left;
        margin-right: 10px;
      }

      .radio-group {
        display: flex;

        ::v-deep .el-radio-button__inner {
          padding: 9px 12px;
          font-size: 14px;
          font-weight: 400;
        }

        .el-radio-button {}
      }

      .el-select {
        width: 200px;
      }
    }
  }

  .dialog-footer {
    padding: 10px 17px;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    border-top: 1px solid #e8e8e8;

    button {
      width: 65px;
      height: 32px;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;

      &.cancel-btn {
        background: #fff;
        border: 1px solid #d9D9D9;
        color: #333;
        margin-right: 10px;
      }

      &.confirm-btn {
        background: #325FAC;
        color: #fff;
        border: none;
      }
    }
  }
}
</style>